export const getCookie = cname => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const formatDate = (format, date) => {
  let dateStr = format;
  const MONTH_NAMES = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const tokens = format.match(/([dmy]+)/g);

  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];

    switch (token) {
      case 'd':
        dateStr = dateStr.replace(token, date.getDate());
        break;
      case 'dd':
        // Zero padded day
        dateStr = dateStr.replace(token, ('0' + date.getDate()).slice(-2));
        break;
      case 'm':
        dateStr = dateStr.replace(token, date.getMonth() + 1);
        break;
      case 'mm':
        // Zero padded month
        dateStr = dateStr.replace(token, ('0' + (date.getMonth() + 1)).slice(-2));
        break;
      case 'mmm':
        dateStr = dateStr.replace(token, MONTH_NAMES[date.getMonth()]);
        break;
      case 'yyyy':
        dateStr = dateStr.replace(token, date.getFullYear());
        break;
    }
  }

  return dateStr;
};

export const queryString = queryObject => {
  if (typeof queryObject === 'object') {
    const keys = Object.keys(queryObject);
    if (keys.length > 0) {
      return `?${keys
        .reduce((accumulator, each) => {
          accumulator.push(`${each}=${queryObject[each]}`);
          return accumulator;
        }, [])
        .join('&')}`;
    }
  }
  return '';
};

export const swap =
  (x, y) =>
    ([...array]) => {
      [array[x], array[y]] = [array[y], array[x]];
      return array;
    };

export const setAuthHeader = token => {
  return { headers: { authorization: token } };
};

export const expand = obj => {
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; ++i) {
    const key = keys[i];
    const subkeys = key.split(/,\s?/);
    const target = obj[key];
    delete obj[key];
    subkeys.forEach(key => {
      obj[key] = target;
    });
  }
  return obj;
};

const getOffsetTop = el => {
  const elTop = el.getBoundingClientRect().top;
  const bodyTop = document.body.getBoundingClientRect().top;
  return elTop - bodyTop;
};

export const scrollTo = (el, offset = 0) => {
  const scrollPos = getOffsetTop(el) - offset;
  window.scrollTo(0, scrollPos);
};

export const scrollToError = errors => {
  const errorValues = Object.values(errors);
  if (errorValues.length === 0) return;
  if (['number', 'text', 'textarea', 'tel'].includes(errorValues[0].ref.type)) {
    errorValues[0].ref.focus();
  } else {
    const headerHeight = document.getElementsByClassName('header-bar')[0].offsetHeight;
    scrollTo(errorValues[0].ref.parentElement, headerHeight);
  }
};

export const getStorageData = async (KEY, deleteData = true) => {
  const { default: storage } = await import('@quikr/ui/src/helpers/Storage');
  const data = await storage.get(KEY);
  const hasData = data !== 'undefined' && data !== undefined;
  const parsedData = hasData ? JSON.parse(data) : {};
  deleteData && storage.delete(KEY);
  return Object.keys(parsedData || {}).length > 0 ? parsedData : false;
};

export const moneyFormat = {
  ones: ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'],
  tens: ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'],
  teens: [
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen'
  ],

  convertCrores: num => {
    if (num >= 10000000) {
      return `${moneyFormat.convertCrores(
        Math.floor(num / 10000000)
      )} Crore ${moneyFormat.convertLakhs(num % 10000000)}`;
    } else return moneyFormat.convertLakhs(num);
  },

  convertLakhs: num => {
    if (num >= 100000) {
      return `${moneyFormat.convertLakhs(
        Math.floor(num / 100000)
      )} Lakh ${moneyFormat.convertThousands(num % 100000)}`;
    } else return moneyFormat.convertThousands(num);
  },

  convertThousands: num => {
    if (num >= 1000) {
      return `${moneyFormat.convertHundreds(
        Math.floor(num / 1000)
      )} Thousand ${moneyFormat.convertHundreds(num % 1000)}`;
    } else return moneyFormat.convertHundreds(num);
  },

  convertHundreds: num => {
    if (num > 99) {
      return `${moneyFormat.ones[Math.floor(num / 100)]} Hundred ${moneyFormat.convertTens(
        num % 100
      )}`;
    } else return moneyFormat.convertTens(num);
  },

  convertTens: num => {
    if (num < 10) return moneyFormat.ones[num];
    else if (num >= 10 && num < 20) return moneyFormat.teens[num - 10];
    else return moneyFormat.tens[Math.floor(num / 10)] + ' ' + moneyFormat.ones[num % 10];
  },

  convert: num => {
    if (num === '' || num === undefined || isNaN(num)) return '';
    else if (num === '0') return 'Zero';
    else return moneyFormat.convertCrores(num);
  }
};
